import { QueryClient } from "react-query";
export var queryClient = new QueryClient();
